<div class="tab-pane fade active show" id="v-pills-home" role="tabpanel" aria-labelledby="v-pills-home-tab">
  <div class="card">
    <div class="card-body">
      <form class="text-dark" [formGroup]="relatedFinanceInformation">
        <div class="row">
          <div class="form-group col-md col-sm-12">
            <label for="buyingCriteriaBasedOn">Buying Criteria Based On</label>
            <select class="form-select form-control form-control-sm" id="buyingCriteriaBasedOn" formControlName="buyingCriteriaBasedOn">
              @for (buyingCriteria of buyingCriterias; track buyingCriteria) {
                <option [value]="buyingCriteria.name">
                {{buyingCriteria.name}}</option>
              }
            </select>
          </div>
          <div class="form-group col-md col-sm-12">
              <label for="buyingRate">Buying Rate</label>
              <percent-input [id]="'buyingRate'" [control]="relatedFinanceInformation.get('buyingRate')"></percent-input>
          </div>
          <div class="form-group col-md col-sm-12">
            <label for="federalId">Federal Id Number</label>
            <input class="form-control form-control-sm text-dark" type="text" id="federalId" formControlName="federalId" autocomplete="off">
          </div>
        </div>
      </form>
    </div>
    <div class="card-footer text-right">
        <button class="btn btn-sm btn-primary" (click)="save()" [disabled]="!relatedFinanceInformation.valid || contactId == 0">Save</button>
        @if (calledFrom !== null) {
          <button class="btn btn-sm btn-primary">Cancel &amp; Close</button>
        }
    </div>
  </div>
  @if (calledFrom == null) {
    <div class="text-right">
      <button class="btn btn-sm btn-danger" (click)="deactivateRole()">Deactivate Role</button>
    </div>
  }
</div>
